export default __webpack_public_path__ + "static/media/circle-flags_dk.16ec0180.svg";